import { Component, OnInit } from '@angular/core';
import { Router, RouterEvent } from '@angular/router';
import { GlobalService } from '../global.service';
import { ModalController } from '@ionic/angular';
@Component({
  selector: 'app-skills',
  templateUrl: './skills.page.html',
  styleUrls: ['./skills.page.scss'],
})
export class SkillsPage implements OnInit {

    ismodal = false;
    character = GlobalService.CHARACTER;
    customSkillPoints = GlobalService.CHARACTER.skillPoints;
    constructor(private router: Router, private modalController: ModalController) { }

    ngOnInit() {
    }
    close() {
        this.modalController.dismiss();
    }
    skillAllowed(skill) {
        return skill.roles.length==0 || skill.roles.indexOf(this.character.role) !=-1;
    }
    change(skill,dir) {
            skill.value += dir;
            this.character.skillPoints -= dir;
    }
    setPoints() {
        if (this.customSkillPoints == null) { this.customSkillPoints = 0; }
            this.character.skillPoints = this.customSkillPoints;
            this.character.skillPointsAllocation = this.character.skillPoints;
            GlobalService.ResetSkills();
        
    
    }

}
